import ContactMe from "./YogaContactMe";
import InstagramEmbed from "./YogaInstagramEmbed";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import MyOfferings from "./YogaOfferings";
import Event from "./events";


export default function YogaLandingPage() {
    // const imageUrl = 'https://www.sinaklughardt.com/static/media/arizona_yoga.ee0824a4294c9a19e376.jpeg';

    return (
        <>
        {/* <Helmet>
            <title>Sina In Flux Yoga | San Diego</title>
            <meta property="og:title" content="Sina In Flux Yoga"/>
            <meta property="og:description" content="Yoga that aligns with nature’s rhythms. Join outdoor yoga classes in San Diego to feel at home in your body and shine your light." />
            <meta property="og:image" content={imageUrl} />
        </Helmet> */}
<div className="relative w-full h-[600px] md:h-[800px] overflow-hidden">
  <img
    src={require("./images/prayer_horizontal.jpg")}
    alt="Sina Klughardt Yoga"
    className="h-full w-full object-cover object-center"
  />

  <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center text-[#735449] text-lg font-bold md:text-3xl whitespace-nowrap">
    <p>SINA KLUGHARDT • IN FLUX YOGA</p>
    {/* <div className="md:hidden text-sm font-serif">
    <p className="pt-5">flow freely</p>
    <p>root deeply</p>
    <p>all are welcome</p>
    </div> */}
  </div>
</div>


<div className="flex items-center justify-center my-20">
  <div className="flex flex-col md:flex-row max-w-[1200px] w-full items-center justify-center px-5 md:px-10">

    <div className="md:w-1/2 flex justify-center">
      <img
        className="rounded h-60 w-60 md:h-80 md:w-80"
        src={require("./images/profile_pic.jpg")}
        alt="Sina Klughardt Headshot"
      />
    </div>

    <div className="md:w-1/2 mt-8 md:mt-0 text-[#735449]">
      <h1 className="text-2xl font-bold text-center md:text-left">
        ABOUT ME
      </h1>

      <p className="mt-5 md:mr-10 md:text-lg">
        I am Sina, a San Diego based yoga & pilates teacher from Germany! My intention is to help people reconnect with their inner rhythms and remember the natural wisdom living inside of them.
      </p>

      <p className="my-3 md:text-lg">
        My path has taken me across continents — from my roots in Germany to building a new home here in San Diego. Along the way, I’ve grown, explored, and learned to listen more deeply to myself, others, and the world around me. Nature keeps teaching me, and I’m here to share that connection through movement, breath, and community.
      </p>
    </div>

  </div>

</div>

<Event />

<div className="grid place-items-center mt-20">
  {/* <ContactMe /> */}
  <InstagramEmbed />
</div>
        </>
    );
}
